@if (items?.length > 0 && (size$ | async); as size) {
  @if (title) {
    <h3 class="h3-component">{{ title }}</h3>
  }
  @if (autoPlay) {
    <div (mouseover)="pause()" (mouseleave)="play()">
      <ng-container  *ngTemplateOutlet="slides; context: { items: items, size: size }"></ng-container>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="slides; context: { items: items, size: size }"></ng-container>
  }
}

<ng-template #slides let-size="size" let-items="items">
  @if (!hideButtons && (isDesktop() | async)) {
    <div class="buttons-container" [hidden]="!(isDesktop() | async)">
      @if (size < items.length) {
        <button
          class="previous"
          (click)="arrowPrevious($event, size)"
          [disabled]="isPreviousDisabled()"
          >
          <cx-icon [type]="previousIcon"></cx-icon>
        </button>
      }
      @if (size < items.length) {
        <button
          class="next"
          tabindex="-1"
          (click)="arrowNext($event, size)"
          [disabled]="isNextDisabled(size)"
          >
          <cx-icon [type]="nextIcon"></cx-icon>
        </button>
      }
    </div>
  }
  <div [class]="'carousel-panel '+ animation" [ngClass]="(!hideButtons ? 'show-buttons ' : '') + 'size-' + size" [draggable]="true" >
    <div class="slides slides-container">
      @for (_ of items; track _; let i = $index) {
        @if (enableMouseActions) {
          @if (i % size === 0) {
            <div class="slide slide-container slide-action"
              [draggable]="true"
              [class.active]="i === activeSlide"
              (mousedown)="mouseDownSlide($event)"
              (mouseup)="mouseUpSlide($event, size)"
              (click)="handleClick(_)"
              >
              @for (item of items | slice: i:i + size; track item; let j = $index) {
                @if (item | async; as data) {
                  <div class="item slide-item {{i}}" [class.active]="i === activeSlide" >
                    <ng-container *ngTemplateOutlet="template; context: { item: data }" ></ng-container>
                  </div>
                }
              }
            </div>
          }
        } @else {
          @if (i % size === 0) {
            <div class="slide slide-container plain" [draggable]="true" [class.active]="i === activeSlide" >
              @for (item of items | slice: i:i + size; track item; let j = $index) {
                @if (item | async; as data) {
                  <div class="item slide-item" [class.active]="i === activeSlide" >
                    <ng-container *ngTemplateOutlet="template; context: { item: data }" ></ng-container>
                  </div>
                }
              }
            </div>
          }
        }
      }
    </div>
  </div>
  @if (!hideIndicators && size < items.length) {
    <div class="indicators">
      <ng-container *ngTemplateOutlet="indicators; context: {size: size}"></ng-container>
    </div>
  }
</ng-template>

<ng-template #indicators let-size="size">
  @for (_ of items; track _; let i = $index) {
    @if (i % size === 0) {
      <button  (focus)="activeSlide = i" [disabled]="i === activeSlide" tabindex="-1" >
        <cx-icon [type]="indicatorIcon"></cx-icon>
      </button>
    }
  }
</ng-template>


